import React from 'react';
import { outcomes } from '../data/content';
export function OutcomesSection() {
  return <section className="bg-cream px-4 py-6 sm:px-6" data-id="element-152" data-mp="1bdptldkfvhjr">
      <h2 className="text-center font-heading text-lg font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-153" data-mp="1bcxx80j0pfsf">
        This isn’t just about having more activity ideas
        <span className="mt-0.5 block text-terracotta" data-id="element-154" data-mp="12ew03w2en7af">
          It’s about having a complete activity system.
        </span>
      </h2>

      <ul className="mx-auto mt-3.5 grid max-w-2xl gap-1.5 sm:grid-cols-2" data-id="element-155" data-mp="1z5o6u33g7mzj">
        {outcomes.map(outcome => <li key={outcome.title} className="flex gap-2.5 rounded-md border-l-4 border-teal bg-white px-3 py-2" data-id="element-156" data-mp="1pe0i49ya0k1r">
            <span className="text-lg leading-none" aria-hidden="true" data-id="element-157" data-mp="1lbnd5nrcsq61">
              {outcome.emoji}
            </span>
            <div data-id="element-158" data-mp="2hvmguoqt3q5t">
              <h3 className="font-heading text-[13px] font-extrabold uppercase leading-tight text-navy" data-id="element-159" data-mp="2hw5tpr1lnocz">
                {outcome.title}
              </h3>
              <p className="mt-0.5 text-[12px] font-medium leading-snug text-graphite" data-id="element-160" data-mp="owo4qtue4a61">
                {outcome.description}
              </p>
            </div>
          </li>)}
      </ul>
    </section>;
}